import React, {useEffect, useState} from 'react';
import {CircularProgress, IconButton, Tooltip} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import {makeStyles} from "@material-ui/core/styles";
import {TopupPriceService} from "../../../service/topup/TopupPriceService";
import AllowAccess from "../../Access/AllowAccess/AllowAccess";
import Access from "../../Access/AllowAccess/Access";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '0px',
        lineHeight: 1.2,
    },
    label: {
        fontSize: '13px',
        fontWeight: 600,
        color: '#ffffff',
        lineHeight: 1.2,
    },
    value: {
        fontSize: '14px',
        fontWeight: 700,
        color: '#ffffff',
        lineHeight: 1.2,
    },
    error: {
        fontSize: '13px',
        color: theme.palette.error.main,
    },
    refreshIcon: {
        color: '#ffffff',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
}));

const ShowTopupAvailableBalance: React.FC = () => {
    const classes = useStyles();
    const [balance, setBalance] = useState<number | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | undefined>(undefined);

    const fetchBalance = async () => {
        setLoading(true);
        setError(undefined);
        const response = await TopupPriceService.getAvailableBalance();
        if (response.success) {
            setBalance(response.data);
        } else {
            setError("Error al obtener el saldo");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchBalance();
    }, []);

    return (
        <AllowAccess any={[Access.CREATE_TOPUP_PRICE]} isRootAgency={true}>
            <div className={classes.container}>
                <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                    <span className={classes.label}>Saldo disponible en el proveedor:</span>
                    <Tooltip title="Actualizar">
                        <span>
                            <IconButton size="small" onClick={fetchBalance} disabled={loading} className={classes.refreshIcon}>
                                <RefreshIcon fontSize="small"/>
                            </IconButton>
                        </span>
                    </Tooltip>
                </div>
                {loading ? (
                    <CircularProgress size={16} style={{color: '#ffffff'}}/>
                ) : error ? (
                    <span className={classes.error}>{error}</span>
                ) : (
                    <span className={classes.value}>
                        {balance !== undefined
                            ? new Intl.NumberFormat('es-CU', {style: 'currency', currency: 'CUP'}).format(balance)
                            : '-'}
                    </span>
                )}
            </div>
        </AllowAccess>
    );
};

export default ShowTopupAvailableBalance;
